// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5bf99563","977":"2524c1cc"}[chunkId] + ".chunk.js";
};